
$(document).ready(function () {
  $(".unsystem-table tbody tr").each(function () {
    $(this).find('td a').parent().css('word-break', 'break-all');
    $(this).find('td').removeAttr('bgcolor');
    $(this).find('td').css('background-color', '#ffffff');
    $(this).find('td a').attr('target', function () {
      if (this.host == location.host) return '_self'
      else return '_blank'
    });
  })
  var i = 1;
  $(".unsystem-table-logo tbody tr").each(function () {
    $(this).first().nextAll().addClass("unsystem-table-logo-tr")
    $(this).find('td a').parent().css('word-break', 'break-all');
    $(this).find('td').removeAttr('bgcolor');
    $(this).find('td').css('background-color', '#ffffff');
    $(this).find('td a').attr('target', function () {
      if (this.host == location.host) return '_self'
      else return '_blank'
    });
    //$(".logo-img-4,.logo-img-41,.logo-img-57,.logo-img-44,.logo-img-52,.logo-img-107,.logo-img-89,.logo-img-61,.logo-img-38,.logo-img-72,.logo-img-77,.logo-img-105,.logo-img-92,.logo-img-7,.logo-img-116,.logo-img-156,.logo-img-154,.logo-img-141,.logo-img-127,.logo-img-118,.logo-img-15,.logo-img-19,.logo-img-23,.logo-img-155,.logo-img-152").closest('tr').prev().hide();
    //$('.logo-img-155,.logo-img-50').closest('tr').hide();
    $(this).addClass('logo-img-' + i);
    i++;
  })
});